// extracted by mini-css-extract-plugin
export default {"CodeEditorBox":"CodeEditorBox_CodeEditorBox__3Yd2j","CodeEditorBox__codeWrapper":"CodeEditorBox_CodeEditorBox__codeWrapper__1ey8S"};